import http from "@/api/http";

export default {
  postReview(locationId, rating) {
    return http({
      url: "/location/" + locationId + "/reviews",
      method: "post",
      data: rating
    });
  },
  getLocationReviews(locationId) {
    return http({ url: "/location/" + locationId + "/reviews", method: "get" });
  },
  getUserReviews(){
    return http({ url: "/reviews", method: "get" });
  }
};
